'use strict';

import { Viewer } from '../Viewer/Viewer';
import ObjectAssignDeep from 'object-assign-deep';
import Worker from '../Worker/offscreen.worker';
import { preloadFont } from '../Text/Troika';
import {isIOS, isSafari} from "../../../../../settings";
import {getCurrentLang} from "../../../langSwitcher/langSwitcher";

const DEFAULT_PARAMS = {
  imageSize: 4096,
  slideDuration: 4,
  zoomDuration: 0.3,
  fadeDuration: 1,
  text: {
    settings: {
      font: '',
      fontSize: 0.1,
      anchorX: '50%',
      anchorY: '50%',
      color: '#ffffff',
      lineHeight: 'normal',
      maxWidth: Infinity,
      letterSpacing: 0,
      outlineBlur: 0,
      outlineColor: '#000000',
      outlineOffsetY: 0,
      textAlign: 'center',
      position: 0
    },
    animation: {
      textDuration: 0.4,
    }
  }
};

export class DreamsSlider {
  constructor (canvas,params,callbacks) {
    this.canvas = canvas;
    this.width = canvas.clientWidth;
    this.height = canvas.clientHeight;
    this.params = ObjectAssignDeep(DEFAULT_PARAMS,params,{});
    this.callbacks = callbacks;
    this.pixelRatio = Math.min(window.devicePixelRatio,1);
    this.params.isOffscreen = false;

    if (this.params.text.settings.font.length) {
      preloadFont(
        {
          font: this.params.text.settings.font,
        },() => {});
    }

    if (isIOS || isSafari) {
      this.params.callbacks = this.callbacks;
      this.viewer = new Viewer(this.canvas,this.width,this.height,this.pixelRatio,this.params);
      this.viewer.initScene();
      this.viewer.start();
    } else {
      this.params.isOffscreen = true;
      this.worker = new Worker();
      this.worker.addEventListener('message',this.messageHandler.bind(this));
      const offscreen = canvas.transferControlToOffscreen();
      this.worker.postMessage({
        type: 'init',
        canvas: offscreen,
        width: this.width,
        height: this.height,
        pixelRatio: this.pixelRatio,
        params: this.params
      },[offscreen]);
    }

    this.resizeEvent = this.resizeHandler.bind(this);
    window.addEventListener('resize', this.resizeEvent);
  }

  post(type, data) {
    this.worker.postMessage({
      type,
      data: data
    });
  }

  launch(dataArray) {
    dataArray.sort((prev,next) => prev.order - next.order);
    const userLanguage = getCurrentLang();

    dataArray.forEach(data => {
      const url = new URL(data.imageUrl);
      data.imageUrl = `${url.origin}/resize/image/width=${this.params.imageSize}${url.pathname}`;

      if (data.slogans) {
        data.slogans.forEach(slogan => {
          if (slogan.lang === userLanguage && slogan.value) {
            data.slogan = slogan.value;
          }
        });
      }
    });


    if (this.params.isOffscreen) {
      this.post('loadSlides',dataArray);
    } else {
      this.viewer.loadSlides(dataArray);
    }
  }

  dispose(duration) {
    window.removeEventListener('resize',this.resizeEvent);
    if (this.params.isOffscreen) {
      this.post('dispose',{});
      this.worker.terminate();
    } else {
      this.viewer.dispose();
    }
    return new Promise(resolve => {
      this.canvas.addEventListener('animationend',() => {
        resolve();
      },{once: true});
      this.canvas.style.animation = `fade-out ${duration}s linear forwards`;
    });
  }

  messageHandler({data}) {
    if (this.callbacks[data]) {
      this.callbacks[data]();
    }
  }

  resizeHandler() {
    if (this.params.isOffscreen) {
      this.post('resize',{
        width: this.canvas.clientWidth,
        height: this.canvas.clientHeight
      });
    } else {
      this.viewer.resize(this.canvas.clientWidth,this.canvas.clientHeight);
    }
  }
}

function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}
